var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BuyerCampaignsList',{attrs:{"buyer-campaigns":_vm.pendingApprovalBuyerCampaigns,"is-loading":_vm.isLoading,"page-title":"Pending Approval Buyer Campaigns"},on:{"change-auto-reload":_vm.onChangeAutoReload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }